export default __webpack_public_path__ + "0113d78838b8749da346a6c796e49787.png";